import type { RoofObject, RoofObjectType } from "./contract.ts";

export type RoofObjectPresentationMode = "mapped_footprint" | "mapped_marker";

export interface RoofObjectPresentation {
  type: RoofObjectType;
  mode: RoofObjectPresentationMode;
  widthM: number;
  depthM: number;
  label: string;
  detail: string;
}

const labels: Record<RoofObjectType, string> = {
  skylight: "Skylight",
  chimney: "Chimney flashing zone",
  vent: "Roof vent flashing zone",
  solar_array: "Supplied solar array",
  antenna: "Antenna location",
};

export function objectPresentation(object: RoofObject): RoofObjectPresentation {
  const hasSize = Boolean(object.sizeM && object.sizeM.every((value) => Number.isFinite(value) && value > 0));
  if (!hasSize) {
    return {
      type: object.type,
      mode: "mapped_marker",
      widthM: 0.18,
      depthM: 0.18,
      label: labels[object.type],
      detail: "Detail to be checked",
    };
  }
  return {
    type: object.type,
    mode: "mapped_footprint",
    widthM: object.sizeM![0],
    depthM: object.sizeM![1],
    label: labels[object.type],
    detail: object.type === "solar_array"
      ? "Supplied footprint divided visually into modules; no layout has been calculated."
      : object.type === "skylight"
        ? "Mapped opening with a low curb and indicative surrounding flashing."
        : "Mapped footprint and indicative flashing zone; object height is not inferred.",
  };
}
